export enum AgentHarnessActionTimeoutOutcome {
    Failed = 'failed',
}

export enum AgentHarnessDueDateInvocationMode {
    OnEntryAndOverdueTransition = 'on_entry_and_overdue_transition',
}
